// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__r1lUI","summary":"CartItem_summary__+biga","price":"CartItem_price__B8jCs","amount":"CartItem_amount__1ZI+f","actions":"CartItem_actions__y02e7"};